import React, { createContext, useState, useEffect, useContext } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'en';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    if (language === 'ar') {
      document.documentElement.dir = 'rtl';
      document.documentElement.lang = 'ar';
      // Set Google Translate cookie
      document.cookie = `googtrans=/en/ar; path=/`;
    } else {
      document.documentElement.dir = 'ltr';
      document.documentElement.lang = 'en';
      // Reset Google Translate cookie
      document.cookie = `googtrans=/en/en; path=/`;
    }
  }, [language]);

  const toggleLanguage = (e) => {
    const newLang = e && e.target ? e.target.value : (language === 'en' ? 'ar' : 'en');
    setLanguage(newLang);
    // Reload to apply Google Translate correctly
    window.location.reload();
  };

  const t = (text) => {
    if (language === 'en') return text;
    // Simple basic translation mapping for key UI elements
    const dictionary = {
      "Search Anything": "ابحث عن أي شيء",
      "Dashboard": "لوحة القيادة",
      "Courses": "الدورات",
      "Enrollments": "التسجيلات",
      "Settings": "الإعدادات",
      "Log Out": "تسجيل خروج",
      "Total employees": "إجمالي الموظفين",
      "Total courses": "إجمالي الدورات",
      "Avg learning time": "متوسط وقت التعلم",
      "Completion rate": "معدل الإنجاز",
      "Export CSV": "تصدير CSV",
      "Export Excel (.xlsx)": "تصدير إكسل (.xlsx)"
    };
    return dictionary[text] || text;
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      <div dir={language === 'ar' ? 'rtl' : 'ltr'}>
        {children}
      </div>
    </LanguageContext.Provider>
  );
};
